const axiosLibrary = require("axios");

const axios = axiosLibrary.create({
  baseURL: "https://gydrus.net",
  // baseURL: "http://localhost:5000",
  //   mode: "no-cors",
});

export default axios;
